import EmailTemplatesAPI from 'dashboard/api/emailTemplates';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getEmailTemplates($state) {
    return $state.records.map(t => ({
      id: t.id,
      name: t.name,
      subject: t.subject,
      body: t.body,
      attachments: Array.isArray(t.attachments) ? t.attachments : [],
    }));
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit('SET_UI_FLAGS', { isFetching: true });
    try {
      const { data } = await EmailTemplatesAPI.get();
      const list = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
      commit('SET_RECORDS', list);
    } catch (error) {
      // silently fail — templates list will be empty
    } finally {
      commit('SET_UI_FLAGS', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_RECORDS($state, data) {
    $state.records = data;
  },
  SET_UI_FLAGS($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
